// Type scale for the whole app. Keeps the existing "Lato" family (with a modern
// system fallback stack) and a deliberate, professional heading hierarchy.

const fontFamily = [
  "Lato",
  "-apple-system",
  "BlinkMacSystemFont",
  '"Segoe UI"',
  "Roboto",
  '"Helvetica Neue"',
  "Arial",
  "sans-serif",
].join(",");

const typography = {
  fontFamily,
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: { fontSize: "2.375rem", fontWeight: 600, lineHeight: 1.2 },
  h2: { fontSize: "2rem", fontWeight: 600, lineHeight: 1.22 },
  h3: { fontSize: "1.625rem", fontWeight: 600, lineHeight: 1.25 },
  h4: { fontSize: "1.375rem", fontWeight: 600, lineHeight: 1.3 },
  h5: { fontSize: "1.125rem", fontWeight: 600, lineHeight: 1.35 },
  h6: { fontSize: "1rem", fontWeight: 600, lineHeight: 1.4 },
  subtitle1: { fontSize: "1rem", fontWeight: 500, lineHeight: 1.5 },
  subtitle2: { fontSize: "0.875rem", fontWeight: 500, lineHeight: 1.5 },
  body1: { fontSize: "0.9375rem", fontWeight: 400, lineHeight: 1.55 },
  body2: { fontSize: "0.8125rem", fontWeight: 400, lineHeight: 1.55 },
  button: { fontSize: "0.9375rem", fontWeight: 600, lineHeight: 1.4, textTransform: "none" },
  caption: { fontSize: "0.75rem", fontWeight: 400, lineHeight: 1.4 },
  overline: {
    fontSize: "0.75rem",
    fontWeight: 600,
    lineHeight: 1.4,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
  },
};

export default typography;
